
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uk/claims",
      function () {
        return require("private-next-pages/uk/claims.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uk/claims"])
      });
    }
  